// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2Kg8t","vLegacy":"SelectSecondary_vLegacy__1TEj8","error":"SelectSecondary_error__1iIP2","disabled":"SelectSecondary_disabled__3MhXl"};